import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import icons from "../../utils/Icons";
var ImageModal = function (_a) {
    var imagePath = _a.imagePath, closeModal = _a.closeModal;
    var closeModalHandle = function () {
        closeModal();
    };
    return (_jsx("div", { className: "bg-black min-h-screen absolute top-0 right-0 bottom-0 left-0 z-20 justify-center lg:px-10 px-3", children: _jsxs("div", { className: "relative h-full w-full lg:mx-auto rounded-xl border-slate-300 p-4 opacity-100", children: [_jsx("button", { onClick: function () { return closeModalHandle(); }, className: "text-slate-700 absolute top-[30px] right-[12px]", children: _jsx("img", { src: icons.closeWhite, alt: "" }) }), _jsx("div", { className: "flex h-full items-center justify-center mt-2", children: _jsx("img", { className: "w-full", src: imagePath, alt: "" }) })] }) }));
};
export default ImageModal;
